export const ENDPOINTS = {
  auth: {
    login: "/api/users/login",
    signup: "/api/users/signup",
    requestPasswordReset: "/api/users/request-password-reset",
    resetPassword: "/api/users/reset-password",
  },
  users: {
    me: "/api/users/me",
    stats: "/api/users/me/stats",
    achievements: "/api/users/me/achievements",
    // Level rungs plus the distinction they lead to. Deliberately not part of
    // `stats`: reading `stats` consumes the one-shot celebration flags, so a
    // second surface polling it would swallow the dashboard's toast.
    levelLadder: "/api/users/me/level-ladder",
    deleteMe: "/api/users/delete_me",
    // Unit system and diet setting, plus the diet vocabulary to render it with.
    // GET is safe to poll — unlike `stats`, it consumes no celebration state.
    preferences: "/api/users/me/preferences",
    // Clears the one-shot goal/level-up notifications once the cooking view
    // has celebrated them, so /dashboard does not replay the same moment.
    clearCelebrations: "/api/users/me/stats/goal-updates",
  },
  techniques: {
    // Full profile grid: every displayable technique with tier and reps.
    me: "/api/techniques/me",
    // Compact dashboard card: recently moved techniques plus one forward pointer.
    card: "/api/techniques/me/card",
    // "Got it" — POST collapses a technique's explanation, DELETE re-expands it.
    dismiss: (id) => `/api/techniques/${id}/dismiss`,
  },
  goals: {
    me: "/api/goals/me",
    nameList: "/api/goals/goal_name_list",
    add: "/api/goals/add_goal",
  },
  schedule: {
    programs: "/schedule/programs",
    deleteProgram: (id) => `/schedule/program/${id}`,
    programTitles: (id) => `/schedule/programs/${id}/recipes_titles`,
    programCompletedRecipes: (id) => `/schedule/programs/${id}/completed_recipes`,
    programActiveIngredients: (id) => `/schedule/programs/${id}/active_program_ingredients`,
    programIngredients: (id) => `/schedule/programs/${id}/ingredients`,
    recipeDetails: (id) => `/schedule/recipes/${id}/details`,
    completeRecipe: (recipeId, programId) =>
      `/schedule/recipes/${recipeId}/complete?program_id=${programId}`,
    replaceRecipe: (programId, recipeId) =>
      `/schedule/programs/${programId}/recipes/${recipeId}/replace`,
    // Drops the recipe and shrinks the week. Refused once the schedule has its
    // first completion, same as replace.
    removeRecipe: (programId, recipeId) => `/schedule/programs/${programId}/recipes/${recipeId}`,
    slotAlternatives: (programId, recipeId, limit = 5) =>
      `/schedule/programs/${programId}/recipes/${recipeId}/alternatives?limit=${limit}`,
    recipeSearch: "/schedule/recipes/search",
    create: "/schedule/create",
    build: "/schedule/build",
    // Browse catalog. Unlike recipeSearch (bounded, slot-scoped, no offset)
    // this one pages through the whole catalog.
    catalog: "/schedule/catalog",
    catalogFilters: "/schedule/catalog/filters",
    catalogStats: "/schedule/catalog/stats",
  },
  pantry: {
    myItems: "/api/pantry-items/my",
    removeMyItem: (id) => `/api/pantry-items/my/${id}`,
    pantryNameList: "/api/pantry-items/pantry_name_list",
    ingredientNameList: "/api/pantry-items/ingredient_name_list",
    blacklisted: "/api/pantry-items/blacklisted",
    removeBlacklisted: (id) => `/api/pantry-items/blacklisted/${id}`,
    // Ingredient families ("fish", "mushroom"). A group is picked and removed
    // as ONE thing — the members it covers are expanded server-side on every
    // query, never stored, so there is nothing here to enumerate or undo.
    ingredientGroups: "/api/pantry-items/ingredient_groups",
    removeBlacklistedGroup: (slug) =>
      `/api/pantry-items/blacklisted/group/${encodeURIComponent(slug)}`,
    addIngredient: "/api/pantry-items/ingredients",
    addPantryItem: "/api/pantry-items/add-pantry-item",
  },
  taste: {
    profile: "/api/preferences/taste",
    override: (dimension, key) => `/api/preferences/taste/${dimension}/${encodeURIComponent(key)}`,
  },
  collections: {
    savedRecipes: "/api/collections/recipes/saved",
    savedPrograms: "/api/collections/programs/saved",
    programSave: (id) => `/api/collections/programs/${id}/save`,
    recipeInteraction: (id) => `/api/collections/recipes/${id}`,
    recipeSave: (id) => `/api/collections/recipes/${id}/save`,
    rateRecipe: (id) => `/api/collections/recipes/${id}/rate`,
  },
  admin: {
    addRecipe: "/api/add_recipe",
  },
  onboarding: {
    submit: "/api/onboarding/submit",
    status: "/api/onboarding/status",
  },
};
